module.exports = __webpack_public_path__ + "img/horbach_quadratisch_w850.85e6b4d4.webp";